// extracted by mini-css-extract-plugin
export default {"body":"NewCheck_body__S0aGU","content":"NewCheck_content__GUw26","forms":"NewCheck_forms__UYqGM","forms--step2":"NewCheck_forms--step2__cdrtz"};